import { apiClient } from 'modules/app/configs/axios';

const endpoint = '/admin/customers';

export const getAllCustomers = async () => {
  try {
    const response = await apiClient.get(`${endpoint}`);

    return response.data;
  } catch (error: any) {
    throw error.data;
  }
};


export const setCustomStripeFlag = async (companyId: number, checked: boolean) => {
  try {
    const response = await apiClient.post(`${endpoint}/set_custom_stripe_flag`, {
      company_id: companyId,
      is_custom_stripe: checked,
    });
    return response.data;

  } catch (error: any) {
    throw error.data;
  }
};

export const setAutoRecordingFlag = async (companyId: number, checked: boolean) => {
  try {
    const response = await apiClient.post(`${endpoint}/set_auto_recording`, {
      company_id: companyId,
      is_auto_recording_enabled: checked,
    });
    return response.data;

  } catch (error: any) {
    throw error.data;
  }
};

export const setAllowFinancialTechnician = async (companyId: number, checked: boolean) => {
  try {
    const response = await apiClient.post(`${endpoint}/set_financial_technician`, {
      company_id: companyId,
      allow_financial_technician: checked,
    });
    return response.data;

  } catch (error: any) {
    throw error.data;
  }
};



